import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { CSSProperties, ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

export type SortableContainerProps = {
  id: UniqueIdentifier;
  children: ReactNode;
  className?: string;
};

const Handle = styled.span`
  position: absolute;
  height: 36px;
  width: 36px;
  z-index: 1;
  cursor: pointer;
`;

const Root = styled.div`
  position: relative;
`;

export const SortableContainer = ({ id, children, className }: SortableContainerProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });
  const style: CSSProperties = {
    transform: transform ? CSS.Transform.toString(transform) : undefined,
    transition,
    opacity: isDragging ? 0.4 : 1,
  };
  return (
    <Root className={className} ref={setNodeRef} style={style}>
      <Handle {...attributes} {...listeners} />
      {children}
    </Root>
  );
};
